import { Group, Switch, UnstyledButton } from '@mantine/core';
import Text from '@ui/components/Text/Text';
import Icon from '@ui/components/Icon/Icon';
import HoverCard from '@ui/components/HoverCard/HoverCard';
import type Project from 'src/entities/project';
import useViewOnlyLink from '../ViewOnlyLink/useViewOnlyLink';

const VIEW_ONLY_TOOLTIP = 'See project images only, no collaboration.';

type ViewOnlyLinkRowProps = {
	project: Project;
	withDownloads: boolean;
};

const ViewOnlyLinkRow = ( { project, withDownloads }: ViewOnlyLinkRowProps ) => {
	const {
		showSuccessMessage,
		copyShareLink,
		boxStyles,
		onLinkEnabledToggled
	} = useViewOnlyLink( { project, withDownloads } );

	return (
		<Group position="apart" px={8} h={36} style={boxStyles}>
			<Group spacing={6}>
				<Switch
					size="xs"
					checked={project.viewOnlyLinkEnabled}
					onChange={onLinkEnabledToggled}
				/>
				<Text variant="footnote" color="var(--color-text-primary)">View Only - Anonymous</Text>
				<HoverCard position="bottom" offset={6} withArrow withinPortal>
					<HoverCard.Target>
						<div style={{ display: 'flex', alignItems: 'center', paddingTop: 2 }}>
							<Icon icon="info_outlined" size={14} color="var(--color-text-secondary)" />
						</div>
					</HoverCard.Target>
					<HoverCard.Dropdown style={{ maxWidth: 220, padding: '7px 8px', backgroundColor: '#061324', border: 'none', borderRadius: 4 }}>
						<Text variant="caption-regular" color="white" style={{ textAlign: 'center' }}>
							{VIEW_ONLY_TOOLTIP}
						</Text>
					</HoverCard.Dropdown>
				</HoverCard>
			</Group>
			{project.viewOnlyLinkEnabled && (
				<UnstyledButton onClick={copyShareLink} style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
					<Icon icon="link" size={18} color="var(--color-primary-base)" />
					<Text variant="footnote-semibold" color="var(--color-primary-base)">
						{showSuccessMessage ? 'Copied' : 'Copy'}
					</Text>
				</UnstyledButton>
			)}
		</Group>
	);
};

export default ViewOnlyLinkRow;
